import { render } from "./FloatingBottomBar.vue?vue&type=template&id=4b683a56&ts=true"
import script from "./FloatingBottomBar.vue?vue&type=script&lang=ts"
export * from "./FloatingBottomBar.vue?vue&type=script&lang=ts"

import "./FloatingBottomBar.vue?vue&type=style&index=0&id=4b683a56&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__